<script setup>
import { computed, watch, ref, reactive } from 'vue';
import { useLayout } from '@/layout/composables/layout';
import AppFooter from './AppFooter.vue';
import AppSidebar from './AppSidebar.vue';
import AppTopbar from './AppTopbar.vue';

const { layoutConfig, layoutState, isSidebarActive, resetMenu, setDarkMode } = useLayout();

const outsideClickListener = ref(null);

watch(isSidebarActive, (newVal) => {
    if (newVal) {
        bindOutsideClickListener();
    } else {
        unbindOutsideClickListener();
    }
});
const containerClass = computed(() => {
    return {
        'layout-overlay': layoutConfig.menuMode === 'overlay',
        'layout-static': layoutConfig.menuMode === 'static',
        'layout-static-inactive': layoutState.staticMenuDesktopInactive && layoutConfig.menuMode === 'static',
        'layout-overlay-active': layoutState.overlayMenuActive,
        'layout-mobile-active': layoutState.staticMenuMobileActive
    };
});

function bindOutsideClickListener() {
    if (!outsideClickListener.value) {
        outsideClickListener.value = (event) => {
            if (isOutsideClicked(event)) {
                resetMenu();
            }
        };
        document.addEventListener('click', outsideClickListener.value);
    }
}

function unbindOutsideClickListener() {
    if (outsideClickListener.value) {
        document.removeEventListener('click', outsideClickListener);
        outsideClickListener.value = null;
    }
}

const isOutsideClicked = (event) => {
    const sidebarEl = document.querySelector('.layout-sidebar');
    const topbarEl = document.querySelector('.layout-menu-button');

    return !(sidebarEl.isSameNode(event.target) || sidebarEl.contains(event.target) || topbarEl.isSameNode(event.target) || topbarEl.contains(event.target));
};

const blogDto = reactive(window.blogDto)

window.hideGhostConnectionMessage = () => {
    blogDto.ghostConnected = true;
}

//check if we need to activate admin dark theme
if (localStorage.getItem('outpostAdminDarkTheme') === 'true') {
    setDarkMode()
}
</script>

<template>
    <div class="layout-wrapper" :class="containerClass">
        <app-topbar></app-topbar>
        <app-sidebar></app-sidebar>
        <div class="layout-main-container">
            <div class="layout-main">
                <Message v-if="!blogDto.ghostConnected" severity="error" icon="pi pi-times-circle">
                    Outpost cannot work until you <a href="https://outpost.pub/docs/how-do-i-connect-my-ghost-site-to-outpost-doc/" target="_blank">connect</a> Outpost to Ghost.
                </Message>
                <router-view></router-view>
            </div>
            <app-footer></app-footer>
        </div>
        <!--
        <app-config></app-config>
        -->
        <div class="layout-mask animate-fadein"></div>
    </div>
    <Toast>
        <template #message="slotProps">
            <i class="pi pi-check pt-1" style="color: green;" v-if="slotProps.message.severity==='success'"></i>
            <i class="pi pi-times-circle pt-1" style="color: #dc2626;" v-if="slotProps.message.severity==='error'"></i>
            <div class="p-toast-message-text">
                <span class="p-toast-summary">{{slotProps.message.summary}}</span>
                <div class="p-toast-detail" v-html="slotProps.message.detail" />
            </div>
        </template>
    </Toast>
</template>

<style lang="scss" scoped></style>
